import { Ajax } from '@shared/Ajax';


export const EquipmentAttachmentsService = {
    getAttachments: (equipmentUuid: string): JQueryPromise<any> => {
        return Ajax({
            url: `/equipment/${equipmentUuid}/attachments`,
        })
    },

    deleteAttachment: (attachmentUuid: string, equipmentUuid: string): JQueryPromise<any> => {
        return Ajax({
            url: `/equipment/${equipmentUuid}/attachment?attachmentId=${attachmentUuid}`,
            method: 'DELETE',
        })
    },

    addNewAttachment: (equipmentUuid: string, data: IAttachmentData): JQueryPromise<any> => {
        return Ajax({
            url: `/equipment/${equipmentUuid}/attachment`,
            method: 'POST',
            data: data,
        })
    }
}
